import styled from "styled-components";

export const StyledCtaPill = styled.span`
  display: inline-block;
  background: #f8ff3c;
  color: #000000;
  font-family: "Verizon-NHG-eDS";
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.25rem;
  padding: 0.75rem 1.5rem;
  border-radius: 999rem;
  transition: background 200ms ease, color 200ms ease;

  a:hover & {
    background: #ffffff;
    color: #ee0000;
  }
`;
